import { config } from '@js/index';
import { enablePointerEvents } from '@utils/pointer-events-control';

export default class StartScene extends Phaser.Scene {
  constructor() {
    super({ key: 'StartScene' });
  }

  preload() {}

  create() {
    const gameState = this.game.__gameState;

    if (window.isLocalHost) enablePointerEvents();

    const cam = this.cameras.main;

    // Build character anim (frames live in the multiatlas loaded by LoadScene)
    if (!this.anims.exists('character')) {
      this.anims.create({
        key: 'character',
        frames: this.anims.generateFrameNames('character', {
          start: 0,
          end: 90,
          zeroPad: 0,
          prefix: 'CHARACTER TOP',
          suffix: '.png',
        }),
        frameRate: 35,
        repeat: -1,
      });
    }

    this.add.image(config.width / 2, config.height / 2, 'startBG');
    this.add
      .sprite(config.width / 2, config.height / 2, 'character')
      .setScale(1.0)
      .play('character');

    this.play = this.add
      .image(640, 640, 'play')
      .setScale(1.05)
      .setInteractive({ cursor: 'pointer' });

    this.bgMusic = this.sound.add('bgMusic');
    // Persist on game so GameScene can fade it out at the end
    this.game.__bgMusic = this.bgMusic;

    this.play.on('pointerover', () => this.play.setTexture('playBlack'));
    this.play.on('pointerout', () => this.play.setTexture('play'));

    this.play.on('pointerdown', () => {
      this.bgMusic.setLoop(true).setVolume(0.08).play();
      this.play.setVisible(false);
      cam.fadeOut(500, 255, 255, 255);
      cam.once('camerafadeoutcomplete', () => {
        this.scene.start('GameScene', gameState);
        this.scene.stop('StartScene');
      });
    });
  }

  update() {}
}
